import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/products'

const ProductsApiV2 = {

  /**
   * Get list of Products
   * Invoke `GET api/v2/admins/products
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = await axios.get(path, { params })
    return response
  },
  /**
   * Get list of Products
   * Invoke `GET api/v2/admins/products
   * @param {object} code - To get options from selected filters
   */
  get_filters_options: async ({ codes }) => {
    const params = {
      codes: codes
    }
    const path   = [ API_PATH, 'filters', 'options' ].join('/')

    const response = await axios.get(path, { params })
    return response
  },
  /**
   * Get list of Products
   * Invoke `GET api/v2/admins/products
   * @param {object} code - To get sizes  related with category id
   */
  get_size_filters_options: async ({ code }) => {
    const params = {
      category_id: code
    }
    const path   = [ API_PATH, 'filters', 'options', 'size' ].join('/')

    const response = await axios.get(path, { params })
    return response
  },
  /**
   * Get list of Products from csv
   * Invoke `GET api/v2/admins/products/csv
   * @param {BinaryType} file - csv file
   */
  get_from_csv: async (file) => {
    const path  = `${API_PATH}/csv`
    let payload = new FormData()
    payload.append('file', file)
    const response = await axios.post(path, payload)
    return response
  },
  /**
   * Get one `Product`
   * @param {object} id product id
   * @return {object} `product`
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },

  /**
   * Get a Product attribute values
   * Used to set field data on particular product when doing edit process
   * @param {number} id - Product id
   */
  edit: async (id) => {
    const path = `${API_PATH}/${id}/edit`

    const response = axios.get(path)
    return response
  },

  /**
   * Update Product attribute (only update `Product` model)
   * @param {number} id - Product id
   * @param {object} payload - Updated attributes
   */
  update: async ({ id, payload }) => {
    const path = `${API_PATH}/${id}`
    const body = {
      product: payload
    }

    const response = axios.patch(path, body)
    return response
  },

  /**
   * get all the products that are bulk discountable
   * and eligible for being uploaded to show their price
   * @returns CSV of products
   */
  bulkDiscountable: async () => {
    const path = `${API_PATH}/bulk_discountable`

    const response = await axios.get(path, {})
    return response
  },

  /**
   * Post bulk discount CSV file to get the previous products price
   * Invoke `GET api/v2/admins/products
   * @param {object} file - Bulk discount CSV file
   */
  showPrice: async ( file ) => {
    const path  = `${API_PATH}/show_price`
    let payload = new FormData()
    payload.append('file', file)
    const response = await axios.post(path, payload)
    return response
  },

  /**
   * Post CSV file to get the previous products price
   * Invoke `GET api/v2/admins/products
   * @param {Array} products - New price data
   */
  bulkDiscount: async (products) => {
    const path = `${API_PATH}/bulk_discount`
    const body = {
      products: products
    }

    const response = await axios.post(path, body)
    return response
  }
}

export default ProductsApiV2
